import { render, staticRenderFns } from "./the-my-account.vue?vue&type=template&id=a05319d8"
import script from "./the-my-account.vue?vue&type=script&lang=js"
export * from "./the-my-account.vue?vue&type=script&lang=js"
import style0 from "./the-my-account.vue?vue&type=style&index=0&id=a05319d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports